// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import GlobalSvg from '@rsuite/icon-font/lib/network/Global';
var Global = createSvgIcon({
  as: GlobalSvg,
  ariaLabel: 'global',
  category: 'network',
  displayName: 'Global'
});
export default Global;